import { Box, Container, Grid, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import banner from '../../../assets/about.png'
import tick from '../../../assets/tick-blue - Copy.png';
import {useParams} from "react-router-dom";
import React from "react";
import {ServicesData} from "./ServicesData";
import about_2 from "../../../assets/about_2.png";
import ContactUs from "../Contact/ContactUs";
import Contact from "../Contact/Contact";

export default function ServicesDetail() {
    const { id } = useParams();

    const services = ServicesData.find(p => p.id.toString() === id);

    if (!services) {
        return <h2>Specialist not found</h2>;
    }
    return (
        <>
            <Box py={6} sx={{ background: 'linear-gradient(#E7F0FF, #E8F1FF)' }}>
                <Container>
                    <Grid container spacing={6} alignItems='center'>
                        <Grid item xs={12} md={6}>
                            <Typography
                                fontWeight={600}
                                color="primary.main"
                            >
                            </Typography>
                            <Typography variant="h2" mb={1}>
                                {services.title}
                            </Typography>
                            <Typography color='#77829D' lineHeight={1.7} textAlign="justify"
                                        sx={{ textJustify: 'inter-word' }}>
                                {services.description}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box
                                component='img'
                                src={services.image}
                                width={1}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Contact/>
        </>

    )
}
